import { render } from "./Loading.vue?vue&type=template&id=1b8a379c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=1b8a379c&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a379c"]])

export default __exports__